import * as cookies from "browser-cookies";

export default () => ({
    id: cookies.get('upcoming-auth-user-id'),
    token: cookies.get('upcoming-auth-token')
});


// WEBPACK FOOTER //
// ./src/user/getLocalUser.ts